/**
 * Created by rathompson on 10/8/21
 * File: TenantNameRenderer
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// import statement lib, local then scss or css

/**
 *   TODO: Brief what is this component/class do
 */
import { Body, classNames } from '@panwds/react-ui'
import { CaretRightIcon } from '@panwds/icons'
import { ARRAY } from '../../../../common/utils/Utils'
import { DATA_TEST_TENANT_NAME } from '../../../../common/constants/TestingDataIds'

const RowExpansionToggle = ({ row }) => {

  const disabled = !ARRAY.hasArray(row?.subRows)

  const className = classNames('cm-box-border cm-border-none cm-p-0 cm-m-0 focus:cm-outline-none cm-bg-transparent cm-rounded cm-mr-1', disabled && 'cm-cursor-not-allowed')

  return (
    <button
      data-testid={DATA_TEST_TENANT_NAME}
      disabled={disabled}
      aria-label={row?.isExpanded ? 'Collapse row' : 'Expand row'}
      {...row?.getToggleRowExpandedProps({
        className
      })}
      type="button"
    >
      <CaretRightIcon size='xs' className={classNames(
        'cm-transition-transform cm-duration-200',
        row?.isExpanded && 'cm-rotate-90',
        disabled && 'cm-cursor-not-allowed'
      )} />
    </button>
  )
}

const TenantNameRenderer = ({ row, value }) => {

  const expandEnabled = row?.depth === 0 && ARRAY.hasArray(row?.subRows)
  const props = expandEnabled ? { ...row?.getToggleRowExpandedProps() } : {}

  return (
    <div className='cm-relative cm-h-full cm-truncate cm-py-2'>
      <div className='cm-flex cm-gap-2'>
        {row?.depth === 0 && <RowExpansionToggle row={row} />}
        <Body
          {...props}
          addClassName={'cm-text-blue-600 cm-truncate'}
        >{value}</Body>
      </div>
    </div>
  )
}

TenantNameRenderer.propTypes = {}
export default TenantNameRenderer
